import { useState, useEffect } from 'react';

function getDeviceType() {

    const windowWidth = window.innerWidth;

    const breakdowns = {
        mobile: 576,
        tablet: 1200,
        // desktop: 1440
    };

    return windowWidth < breakdowns.mobile ?
        {type: 'mobile', useImg:'mobile', available:'imgMobile'}
        : (windowWidth < breakdowns.tablet ?
            {type: 'tablet', useImg:'mobile-weight', available:'imgMobile' }
               : {type: 'desktop', useImg:'desktop', available:'img'});
}

export  function useDeviceType() {
    const [deviceType, setDeviceType] = useState(getDeviceType());

    useEffect(() => {
        function handleResize() {
            setDeviceType(getDeviceType());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return deviceType;
}

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

